import { deflateSync } from 'fflate';
import { isSubpanel, isImageItem, isTextAreaItem, isShapeItem } from './itemHelpers';
export const encodeCimDoc = ({ cimDoc }) => {
    const cimDocToEncode = Object.assign({}, cimDoc); // Spread because we will only delete metadata, preventing cloning is faster
    // Strip metadata from cimDoc for smaller network payload
    delete cimDocToEncode.metadata;
    const documentJson = JSON.stringify(cimDocToEncode);
    const encoder = new TextEncoder();
    const encodedValue = encoder.encode(documentJson);
    const valueDeflated = deflateSync(encodedValue);
    if (typeof btoa === 'undefined') {
        return Buffer.from(valueDeflated).toString('base64');
    }
    return btoa(String.fromCharCode(...valueDeflated));
};
export const buildCimDocForItemPreview = ({ item, cimDocInfo, }) => {
    var _a, _b;
    const transportItem = JSON.parse(JSON.stringify(item));
    const panelWithOnlyItem = {
        id: 'preview-0',
        name: 'preview',
        width: '1mm',
        height: '1mm',
        decorationTechnology: cimDocInfo.decorationTechnology,
    };
    transportItem.rotationAngle = undefined;
    transportItem.zIndex = 0;
    if ('position' in transportItem) {
        transportItem.position = Object.assign(Object.assign({}, transportItem.position), { x: '0mm', y: '0mm' });
    }
    if (isSubpanel(item)) {
        panelWithOnlyItem.subpanels = [transportItem];
    }
    else if (isImageItem(item)) {
        panelWithOnlyItem.images = [transportItem];
    }
    else if (isTextAreaItem(item)) {
        panelWithOnlyItem.textAreas = [transportItem];
    }
    else if (isShapeItem(item)) {
        panelWithOnlyItem.shapes = [transportItem];
    }
    else {
        panelWithOnlyItem.itemReferences = [transportItem];
    }
    return {
        version: cimDocInfo.version,
        fontRepositoryUrl: cimDocInfo.fontRepositoryUrl,
        document: {
            colorPalette: (_a = cimDocInfo.document) === null || _a === void 0 ? void 0 : _a.colorPalette,
            definitions: (_b = cimDocInfo.document) === null || _b === void 0 ? void 0 : _b.definitions,
            panels: [panelWithOnlyItem],
        },
    };
};
//# sourceMappingURL=cimDoc.js.map